import React from "react";
import { X } from "lucide-react";
import { ModalShell } from "./shared";

export const AUTO_CONFIRM_TERM_ARTICLES = [
  {
    title: "제1조 (목적)",
    body: [
      '이 약관은 주식회사 데이토즈(이하 "회사")가 POD24를 통해 제공하는 무통장입금 자동확인 서비스(이하 "서비스")의 이용 조건과 회사 및 이용자의 권리·의무를 정하는 것을 목적으로 합니다.',
    ],
  },
  {
    title: "제2조 (정의)",
    body: [
      '① "이용자"란 POD24에 가입한 사업자 회원 중 이 약관에 동의하고 서비스를 신청한 자를 말합니다.',
      '② "등록 계좌"란 이용자가 입금내역 자동확인을 위해 서비스에 등록한 은행 계좌를 말합니다.',
      '③ "구독"이란 등록 계좌 1개를 기준으로 월간 또는 연간 이용료를 정기적으로 결제하고 서비스를 이용하는 계약을 말합니다.',
      '④ "자동확인"이란 등록 계좌에서 수집한 입금내역과 POD24 주문정보를 비교하여 입금 여부를 자동 또는 수동으로 확인하는 기능을 말합니다.',
    ],
  },
  {
    title: "제3조 (약관의 게시 및 변경)",
    body: [
      "① 회사는 이용자가 약관을 쉽게 확인할 수 있도록 서비스 신청 또는 결제 화면에 게시합니다.",
      "② 회사는 관계 법령을 위반하지 않는 범위에서 약관을 변경할 수 있습니다.",
      "③ 이용자에게 불리한 중요한 변경은 시행일 30일 전까지 서비스 화면 또는 등록된 연락처로 안내합니다.",
      "④ 요금 인상 또는 무료 서비스의 유료 전환은 관계 법령에서 요구하는 절차에 따라 사전 동의 및 고지를 진행합니다.",
    ],
  },
  {
    title: "제4조 (서비스 신청 및 계약 성립)",
    body: [
      "① 이용자는 은행·계좌정보, 예금주, 계좌 조회용 인증정보, 요금제 및 정기결제 수단을 입력하고 약관과 결제 전 안내에 동의하여 서비스를 신청합니다.",
      "② 이용계약은 최초 이용료 결제와 등록 계좌의 자동확인 연동이 모두 완료된 시점에 성립합니다.",
      "③ 회사는 허위 또는 타인 정보 사용, 계좌 사용 권한 미확인, 미지원 은행·계좌 유형, 기술상 제공 곤란 등의 사유가 있으면 신청을 거절하거나 보류할 수 있습니다.",
    ],
  },
  {
    title: "제5조 (서비스 내용)",
    body: [
      "회사는 등록 계좌의 입금 거래내역 수집, 주문정보와의 비교, 조건을 충족한 주문의 자동 입금확인, 확인이 어려운 거래의 별도 표시, 수동 주문 연결 및 구독 상태 조회 기능을 제공합니다.",
    ],
  },
  {
    title: "제6조 (자동확인의 한계)",
    body: [
      "① 서비스는 은행 및 외부 연동사업자가 제공한 거래정보를 기준으로 동작합니다.",
      "② 입금자명·입금액 불일치, 동일 조건 주문 중복, 은행 또는 외부사업자의 장애·점검, 정보 제공 지연, 잘못된 인증정보 등으로 자동확인이 지연되거나 실패할 수 있습니다.",
      "③ 회사는 모든 거래의 자동확인 성공을 보장하지 않습니다. 이용자는 상품 제작·배송 등 주문 처리 전에 최종 입금 여부와 매칭 결과를 확인해야 합니다.",
    ],
  },
  {
    title: "제7조 (이용요금 및 자동결제)",
    body: [
      "① 이용요금은 등록 계좌 1개 기준 월간 10,000원 또는 연간 100,000원이며 부가가치세가 포함된 금액입니다.",
      "② 최초 이용료는 서비스 신청 시 결제됩니다.",
      "③ 구독은 이용자가 해지를 신청하지 않는 한 같은 주기로 자동 갱신됩니다.",
      "④ 다음 결제일은 원칙적으로 최초 결제일을 기준으로 월간 구독은 매월, 연간 구독은 매년 같은 날입니다. 해당 날짜가 없는 경우 결제시스템 기준에 따라 해당 월 말일 등에 처리될 수 있습니다.",
    ],
  },
  {
    title: "제8조 (결제 실패)",
    body: [
      "① 결제수단의 한도 초과, 유효기간 만료 또는 결제사 사정으로 결제가 실패할 수 있습니다.",
      "② 최초 결제가 실패하면 구독은 시작되지 않습니다.",
      "③ 갱신 결제가 실패하면 회사는 3일 동안 하루 1회 결제를 다시 시도할 수 있으며, 유예기간에도 결제가 완료되지 않으면 서비스를 종료할 수 있습니다.",
    ],
  },
  {
    title: "제9조 (청약철회 및 환불)",
    body: [
      "① 서비스 이용이 개시되지 않았고 관계 법령상 청약철회가 가능한 경우 이용자는 결제일로부터 7일 이내에 청약철회를 요청할 수 있습니다.",
      "② 최초 결제 후 계좌 연동에 실패하여 서비스가 시작되지 않은 경우 회사는 결제를 전액 취소합니다.",
      "③ 회사의 책임 있는 사유로 서비스를 정상 제공하지 못한 경우 이용하지 못한 기간 등을 고려하여 이용료를 환불하거나 이용기간을 연장합니다.",
      "④ 서비스 개시 후 이용자의 단순 변심으로 해지하는 경우 이미 결제된 이용기간의 이용료는 일할 환불하지 않으며 이용기간 말일까지 서비스를 제공합니다. 관계 법령상 환불 권리가 인정되는 경우에는 해당 법령이 우선합니다.",
    ],
  },
  {
    title: "제10조 (해지)",
    body: [
      "① 이용자는 구독 관리 화면 또는 서비스 내 문의를 통해 언제든지 해지를 신청할 수 있습니다.",
      "② 해지 신청 후 다음 자동결제는 진행되지 않으며, 서비스는 이미 결제된 현재 이용기간의 마지막 날까지 제공됩니다.",
      "③ 이용기간 종료 후 등록 계좌의 자동확인 기능이 중지됩니다.",
    ],
  },
  {
    title: "제11조 (이용자의 의무)",
    body: [
      "이용자는 본인 또는 소속 사업자가 적법하게 사용할 권한이 있는 계좌만 등록하고, 정확한 정보를 입력하며, 계좌 인증정보와 POD24 계정을 안전하게 관리해야 합니다. 자동확인 결과를 부정한 목적으로 사용하거나 서비스 운영을 방해해서는 안 됩니다.",
    ],
  },
  {
    title: "제12조 (서비스 변경 및 중단)",
    body: [
      "회사는 보안, 유지보수, 기능 개선, 외부기관 정책 변경, 장애 또는 천재지변 등의 사유로 서비스의 일부를 변경하거나 일시 중단할 수 있습니다. 예정된 중단은 가능한 한 사전에, 긴급한 경우에는 사후에 안내합니다.",
    ],
  },
  {
    title: "제13조 (개인정보 및 금융 관련 정보의 처리)",
    body: [
      "① 회사는 서비스 제공에 필요한 범위에서 계좌정보, 예금주, 입금 거래정보, 계좌 조회용 인증정보 및 결제정보를 처리할 수 있습니다.",
      "② 계좌 비밀번호 등 인증정보는 전송 및 저장 과정에서 암호화 등 보호조치를 적용합니다.",
      "③ 결제수단 등록 및 정기결제는 토스페이먼츠가, 계좌 등록 및 입금 거래내역 수집은 바로빌 연동서비스가 처리할 수 있습니다.",
      "④ 구체적인 처리 항목, 목적, 보유기간 및 수탁자는 개인정보처리방침에서 안내합니다.",
    ],
  },
  {
    title: "제14조 (정보의 보관 및 파기)",
    body: [
      "회사는 계약, 결제, 해지 및 분쟁처리를 위해 관계 법령에서 정한 기간 동안 거래기록을 보관할 수 있습니다. 보관기간 종료 또는 처리 목적 달성 후에는 관계 법령과 개인정보처리방침에 따라 파기하며, 법령상 별도 보관 대상은 다른 정보와 분리하여 보관합니다.",
    ],
  },
  {
    title: "제15조 (책임 제한)",
    body: [
      "① 회사는 고의 또는 중대한 과실이 없는 한 이용자가 입력한 정보의 오류, 이용자의 확인 의무 위반, 은행·외부 연동사업자의 정보 오류나 지연, 이용자의 인증정보 관리 소홀 또는 회사가 통제하기 어려운 사유로 발생한 손해에 책임을 지지 않습니다.",
      "② 이 조항은 관계 법령에 따른 회사의 책임을 부당하게 제한하지 않습니다.",
    ],
  },
  {
    title: "제16조 (이용 제한 및 계약 해지)",
    body: [
      "회사는 타인의 계좌·인증정보 무단 사용, 허위정보 입력, 서비스 운영 방해, 이용료 미납 또는 관계 법령·약관의 중대한 위반이 있는 경우 사전 통지 후 이용을 제한하거나 계약을 해지할 수 있습니다. 긴급한 보안 위험이 있으면 선조치 후 통지할 수 있습니다.",
    ],
  },
  {
    title: "제17조 (분쟁 해결)",
    body: [
      "① 회사와 이용자는 서비스 관련 분쟁을 원만하게 해결하기 위해 성실히 협의합니다.",
      "② 이 약관에 정하지 않은 사항은 대한민국 관계 법령과 일반적인 상관례에 따릅니다.",
      "③ 소송이 필요한 경우 관할법원은 민사소송법 등 관계 법령에 따라 정합니다.",
    ],
  },
  {
    title: "제18조 (회사 정보)",
    body: [
      "상호: 주식회사 데이토즈 · 대표자: 김은아 · 사업자등록번호: 637-81-01964 · 통신판매업 신고번호: 제2024-서울금천-1792호",
      "주소: 서울특별시 금천구 디지털로9길 99 스타밸리 805호 · 문의: POD24 서비스 내 문의",
    ],
  },
] as const;


export const AutoConfirmTermsModal = ({ onClose }: { onClose: () => void }) => (
  <div
    className="fixed inset-0 z-[1000000] flex items-center justify-center bg-[#0b1220]/65 p-4 backdrop-blur-[2px]"
    onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}
  >
    <section
      role="dialog"
      aria-modal="true"
      aria-labelledby="auto-confirm-terms-title"
      className="flex max-h-[88vh] w-full max-w-[760px] flex-col overflow-hidden rounded-[12px] bg-white shadow-[0_20px_60px_rgba(6,18,44,0.22)]"
    >
      <header className="flex items-start justify-between gap-4 border-b border-[#e8eaf0] px-5 py-5 sm:px-7">
        <div>
          <h2
            id="auto-confirm-terms-title"
            className="text-lg font-bold tracking-[-0.4px] text-[#222222]"
          >
            무통장입금 자동확인 서비스 이용약관
          </h2>
        </div>
        <button
          type="button"
          aria-label="약관 닫기"
          onClick={onClose}
          className="rounded-lg p-2 text-[#858c9b] transition hover:bg-gray-100"
        >
          <X size={20} />
        </button>
      </header>
      <div className="overflow-y-auto px-5 py-6 sm:px-7">
        <div className="rounded-xl bg-[#f4f7ff] px-4 py-3 text-xs leading-5 text-[#58667f]">
          본 약관은 계좌별 정기결제, 자동갱신, 해지·환불 및 입금 자동확인 서비스의
          이용조건을 규정합니다.
        </div>
        <div className="mt-6 space-y-7">
          {AUTO_CONFIRM_TERM_ARTICLES.map((article) => (
            <article key={article.title}>
              <h3 className="text-sm font-bold text-[#2f3645]">{article.title}</h3>
              <div className="mt-2.5 space-y-1.5 text-[12px] leading-6 text-[#596273]">
                {article.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </article>
          ))}
        </div>
        <p className="mt-8 border-t border-[#eceef2] pt-5 text-[11px] leading-5 text-[#8a92a2]">
          공고일 및 시행일: 2026년 7월 29일
        </p>
      </div>
      <footer className="border-t border-[#e8eaf0] bg-[#fbfcfd] px-5 py-4 sm:px-7">
        <button
          type="button"
          onClick={onClose}
          className="w-full rounded-lg bg-[#4285F4] py-3 text-sm font-bold text-white hover:bg-[#3367D6]"
        >
          확인
        </button>
      </footer>
    </section>
  </div>
);

